import script from "./department-modal.vue?vue&type=script&setup=true&lang=js"
export * from "./department-modal.vue?vue&type=script&setup=true&lang=js"

import "./department-modal.vue?vue&type=style&index=0&id=2bfc2476&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2bfc2476"]])

export default __exports__